import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { DrawerFormDataType } from '@/types';

import { useDeleteProductionCenter } from '../api/delete-production-center';
import { ProductionCenterType } from '../types';

type TProductionCenterControllersReturn = {
  productionCenterDialog: ReturnType<typeof useDisclosureWithData<ProductionCenterType>>;
  productionCenterDrawer: ReturnType<
    typeof useDisclosureWithData<DrawerFormDataType<ProductionCenterType>>
  >;
  handleDeleteProductionCenter: () => void;
};

export function useProductionCenterControllers(): TProductionCenterControllersReturn {
  const productionCenterDialog = useDisclosureWithData<ProductionCenterType>();
  const productionCenterDrawer = useDisclosureWithData<DrawerFormDataType<ProductionCenterType>>();
  const { mutate: deleteProductionCenter } = useDeleteProductionCenter();

  const handleDeleteProductionCenter = () => {
    if (productionCenterDialog.data) {
      deleteProductionCenter(
        {
          id: productionCenterDialog.data.id,
        },
        {
          onSuccess: () => {
            productionCenterDialog.close();
          },
        }
      );
    }
  };

  return {
    productionCenterDialog,
    productionCenterDrawer,
    handleDeleteProductionCenter,
  };
}
